<ng-container *transloco="let t">
  @if (items().length) {
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumbs-list">
      @for (item of items(); track item.url) {
      <li class="breadcrumbs-item">
        <a class="breadcrumbs-link" [routerLink]="item.url">{{
          t(item.labelKey)
        }}</a>
      </li>
      }
    </ol>
  </nav>
  }
</ng-container>
